// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__30agP","header":"MessagesList_header__FFNro","chat":"MessagesList_chat__hCbUh"};